export const GO_LIVE_DATE = new Date('2025-09-04T00:00:00Z');

export const getMinimumQueryDate = (): Date => {
    return GO_LIVE_DATE;
};

export const isBeforeGoLive = (date: Date): boolean => {
    return date < GO_LIVE_DATE;
};